import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import React, { Children, cloneElement, useState } from "react";
import useSmallScreen from "../useSmallScreen";

function MobileBottomNavigation({ children }) {
  const [smallScreen] = useSmallScreen();
  const activeColor = useColorModeValue("#0076ff", "#8fc9f7");
  const [clickState, setClickState] = useState("main");

  const left = Children.toArray(children)[0];
  const right = Children.toArray(children)[1];

  const mobileStyle = {
    maxH: "80vh",
    overflowY: "scroll",
  };
  return (
    <>
      <Flex {...(smallScreen ? mobileStyle : {})}>
        {!smallScreen ? (
          <Flex
            flexDirection={"row"}
            alignItems="flex-start"
            w="100%"
            gap={"20px"}
          >
            {cloneElement(left)}

            {cloneElement(right)}
          </Flex>
        ) : clickState === "main" ? (
          cloneElement(left)
        ) : clickState === "attendees" ? (
          cloneElement(right)
        ) : (
          cloneElement(left)
        )}
      </Flex>

      {smallScreen && (
        <Flex
          flexDirection={"row"}
          justifyContent="space-between"
          p="10px"
          px="10px"
          fontSize={"1.2em"}
        >
          <Text
            color={clickState === "main" ? activeColor : "unset"}
            onClick={() => setClickState("main")}
          >
            Call
          </Text>
          <Text
            color={clickState === "attendees" ? activeColor : "unset"}
            onClick={() => setClickState("attendees")}
          >
            Attendees
          </Text>
        </Flex>
      )}
    </>
  );
}

export default MobileBottomNavigation;
